import { ElementRef, EventEmitter } from '@angular/core';
import { select, Store } from '@ngrx/store';
import uuid from 'uuid-random';
import { getShowRecessions } from 'TargetRatesApp/apps/target-rates-app/state/target-rates.selectors';
import { HIGHCHARTS_YIELD_CURVE_DEFAULT_OPTIONS, MAX_DATES, YIELD_CURVE_EXPORT_OPTIONS, YIELD_CURVE_TERMS, YIELD_CURVE_UNITS, } from './constants';
import { STATIC_PDF_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { ExportOption } from 'ChartApp/ts/services/export-service/enum';
import { ExportService } from 'ChartApp/ts/services/export-service/export.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { TargetRatesService } from 'TargetRatesApp/services/target-rates.service';
import { TargetRatesAppStateService } from 'TargetRatesApp/services/target-rates-app-state.service';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import { downloadUrlWrapper } from 'Angular/utils/download';
import Highcharts from './highcharts/highcharts';
import * as i0 from "@angular/core";
import * as i1 from "TargetRatesApp/services/target-rates.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "TargetRatesApp/services/target-rates-app-state.service";
import * as i4 from "@ngrx/store";
import * as i5 from "../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i6 from "../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i7 from "../../../../../../../ycharts/static/ts/features/components/dropdowns/simple-dropdown/simple-dropdown.component";
import * as i8 from "../../../../../../../ycharts/static/ts/features/components/date-controls/single-date-picker/single-date-picker.component";
const _c0 = ["featureNeededComponent"];
const _forTrack0 = ($index, $item) => $item.id;
function YieldCurveComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "h3", 9);
    i0.ɵɵtext(2, "Treasury Yield Curve");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 10)(4, "ycn-simple-dropdown", 11);
    i0.ɵɵlistener("handler", function YieldCurveComponent_Conditional_0_Template_ycn_simple_dropdown_handler_4_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.handleExport($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("config", ctx_r1.exportOptions);
} }
function YieldCurveComponent_For_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div")(2, "span", 12);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "ycn-single-date-picker", 13);
    i0.ɵɵlistener("dateChangeHandler", function YieldCurveComponent_For_4_Template_ycn_single_date_picker_dateChangeHandler_4_listener($event) { const $index_r4 = i0.ɵɵrestoreView(_r3).$index; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.dateChangeHandler($event, $index_r4)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const dateSeries_r5 = ctx.$implicit;
    const $index_r4 = ctx.$index;
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("bullet bullet-", $index_r4 + 1));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Date ", $index_r4 + 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("appendToBody", true)("selectedDate", dateSeries_r5.date);
} }
function YieldCurveComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function YieldCurveComponent_Conditional_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.addDate()); });
    i0.ɵɵelementStart(1, "span", 15);
    i0.ɵɵtext(2, "+ Add Date");
    i0.ɵɵelementEnd()();
} }
function YieldCurveComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function YieldCurveComponent_Conditional_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.removeLastDate()); });
    i0.ɵɵelementStart(1, "span", 15);
    i0.ɵɵtext(2, "Remove");
    i0.ɵɵelementEnd()();
} }
function YieldCurveComponent_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 6);
} }
function YieldCurveComponent_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 16)(2, "div", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.errorMessage, " ");
} }
function YieldCurveComponent_Conditional_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 18);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("", ctx_r1.chartCssClass, " no-highcharts-darkmode-override"));
    i0.ɵɵproperty("id", ctx_r1.chartElemId);
} }
export class YieldCurveComponent {
    constructor(targetRatesService, featureService, elementRef, targetRatesAppStateService, store) {
        this.targetRatesService = targetRatesService;
        this.featureService = featureService;
        this.elementRef = elementRef;
        this.targetRatesAppStateService = targetRatesAppStateService;
        this.store = store;
        this.dateSeries = [];
        this.isDashboardModule = false;
        this.userCanEdit = false;
        this.chartCssClass = '';
        this.dateSeriesChange = new EventEmitter();
        this.chartElemId = `yieldCurveChart${uuid()}`;
        this.isLoading = false;
        this.exportOptions = YIELD_CURVE_EXPORT_OPTIONS;
        this.errorMessage = '';
        this.chart = null;
        this.showRecessions = false;
        this.exportErrorHandler = (_response) => {
            this.errorMessage = 'Error exporting chart';
        };
        this.startDate = this.elementRef.nativeElement.getAttribute('startDate');
        this.dateSeries = this.elementRef.nativeElement.getAttribute('dateSeries');
        this.isDashboardModule = this.elementRef.nativeElement.getAttribute('isDashboardModule') === 'true';
        this.chartCssClass = this.elementRef.nativeElement.getAttribute('chartCssClass');
        this.userCanEdit = this.elementRef.nativeElement.getAttribute('userCanEdit') === 'true';
    }
    ngOnInit() {
        // initAppState should not be called in the dashboard module
        // This must be in ngOnInit since isDashboardModule isn't initialized yet in the constructor
        if (!this.isDashboardModule) {
            this.targetRatesAppStateService.initAppState();
            this.showRecessionsubscription = this.store
                .select('reducers')
                .pipe(select(getShowRecessions))
                .subscribe((showRecessiones) => {
                this.showRecessions = showRecessiones;
            });
        }
        if (!this.dateSeries) {
            this.dateSeries = [];
            this.addDate();
        }
        this.highchartOptions = { ...HIGHCHARTS_YIELD_CURVE_DEFAULT_OPTIONS };
        this.getChartData();
    }
    ngAfterViewInit() {
        this.exportService = new ExportService(this.targetRatesService, this.featureService, this.featureNeededComponent, this.exportErrorHandler);
    }
    ngOnDestroy() {
        if (this.showRecessionsubscription) {
            this.showRecessionsubscription.unsubscribe();
        }
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }
    }
    rerenderChart() {
        if (this.chart) {
            this.chart.destroy();
            this.chart = Highcharts.chart(this.chartElemId, this.highchartOptions);
        }
    }
    get activeDatesCount() {
        return this.dateSeries.length;
    }
    get canAddMoreDates() {
        return this.activeDatesCount < MAX_DATES;
    }
    dateChangeHandler(date, index) {
        if (!date || index >= this.activeDatesCount) {
            return;
        }
        this.dateSeries[index].date = date;
        this.dateSeriesChange.emit(this.dateSeries);
        this.getChartData();
    }
    addDate() {
        if (this.canAddMoreDates) {
            this.dateSeries.push({
                id: uuid(), // Generate unique ID for tracking
                date: new Date(this.startDate), // Use the given start date as a known valid initial Date value
            });
            this.dateSeriesChange.emit(this.dateSeries);
            this.getChartData();
        }
    }
    removeLastDate() {
        if (this.activeDatesCount > 1) {
            this.dateSeries.pop();
            this.dateSeriesChange.emit(this.dateSeries);
            this.getChartData();
        }
    }
    handleExport(option) {
        switch (option) {
            case ExportOption.pdf:
                if (!this.featureService.userHasFeatures([STATIC_PDF_FEATURE])) {
                    this.featureNeededComponent.openModal(STATIC_PDF_FEATURE);
                }
                else {
                    this.exportPdf();
                }
                break;
            case ExportOption.download:
                this.exportService.exportHandler(ExportOption.download, this.getDates());
                break;
            case ExportOption.export:
                window.location.href = this.targetRatesService.getYieldCurveUrl(this.getDates());
                break;
            default:
                break;
        }
    }
    exportPdf() {
        const dates = this.getDates();
        const fetchUrl = this.targetRatesService.getDownloadPdf(dates, this.showRecessions);
        fetchUrl.subscribe({
            next: (response) => {
                // Set `onbeforeunload` to null to avoid triggering the "unsaved changes" warning when downloading
                // the PDF. After the download finishes, set the value back to the function set by
                // `SavedItemDropdownComponent` .
                window.onbeforeunload = null;
                downloadUrlWrapper(response.report_url).subscribe();
            },
        });
    }
    getDates() {
        return this.dateSeries.map((dateSerie) => dateSerie.date.toLocaleDateString('en-US'));
    }
    getChartData() {
        this.isLoading = true;
        this.errorMessage = '';
        if (!this.dateSeries[0]) {
            this.errorMessage = 'Invalid Dates';
            return;
        }
        const dates = this.getDates();
        this.targetRatesService.getYieldCurveData(dates).subscribe({
            next: (response) => this.renderChart(response),
            error: () => {
                this.errorMessage = 'Unexpected error. Please re-try or contact support.';
                this.isLoading = false;
            },
        });
    }
    renderChart(chartData) {
        this.isLoading = false;
        const { series } = chartData;
        const { dates } = chartData.params;
        this.highchartOptions.series = series.map((serie, seriesIndex) => ({
            data: serie.data.map((value, pointIndex) => ({
                x: YIELD_CURVE_UNITS[pointIndex],
                y: value,
                custom: {
                    date: dates[seriesIndex],
                    term: YIELD_CURVE_TERMS[pointIndex], // Assign term to the point for easier tooltip display.
                },
            })),
        }));
        this.highchartOptions = Highcharts.merge(this.highchartOptions, {
            tooltip: {
                headerFormat: '',
                followPointer: true,
                formatter() {
                    const { y, point } = this;
                    const { date, term } = point.custom;
                    return ` <div class="scatter-tooltip align-right user-select-none max-width-220">
                                <div class="highcharts-tooltip-title">${term} Treasury Yield</div>
                                <table class="highcharts-tooltip-table"><tbody>
                                    <tr><td class="text-right td-ellipsis-content">${y}%</td>
                                        <td class="td-ellipsis-content">${date}</td></tr>
                                </tbody></table>
                            </div>`;
                },
                useHTML: true,
                style: {
                    fontSize: 'inherit',
                },
            },
        });
        const observer = new MutationObserver((_mutations) => {
            if (document.getElementById(this.chartElemId)) {
                observer.disconnect();
                this.chart = Highcharts.chart(this.chartElemId, this.highchartOptions);
            }
        });
        observer.observe(this.elementRef.nativeElement, { childList: true, subtree: true });
    }
}
YieldCurveComponent.ɵfac = function YieldCurveComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || YieldCurveComponent)(i0.ɵɵdirectiveInject(i1.TargetRatesService), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i3.TargetRatesAppStateService), i0.ɵɵdirectiveInject(i4.Store)); };
YieldCurveComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: YieldCurveComponent, selectors: [["ycn-yield-curve"]], viewQuery: function YieldCurveComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
    } }, inputs: { startDate: "startDate", dateSeries: "dateSeries", isDashboardModule: "isDashboardModule", userCanEdit: "userCanEdit", chartCssClass: "chartCssClass" }, outputs: { dateSeriesChange: "dateSeriesChange" }, standalone: false, decls: 12, vars: 4, consts: [["featureNeededComponent", ""], [1, "panel-header"], [1, "panel-content"], [1, "d-flex", "flex-wrap", "align-items-end", "gap-20px", "pt-10", "pb-10"], [1, "d-flex", "flex-column", "gap-1"], [1, "btn", "btn-link"], ["loaderMessage", "Loading...", 2, "grid-template-columns", "auto"], [1, "relative", 2, "height", "320px"], [3, "id", "class"], [1, "panel-title"], [1, "panel-actions"], ["buttonClass", "page-header-action-title", "dropdownClass", "dropdown-menu-with-icons dropdown-menu dropdown-menu-with-icons dropdown-menu-right", 1, "page-header-action", "dropdown", 3, "handler", "config"], [1, "text-thin", "text-gray-40"], [1, "dropdown", "width-90", 3, "dateChangeHandler", "appendToBody", "selectedDate"], [1, "btn", "btn-link", 3, "click"], [1, "text-normal"], [1, "toast", "toast-error", "mt-20"], [1, "toast-text"], [3, "id"]], template: function YieldCurveComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, YieldCurveComponent_Conditional_0_Template, 5, 1, "div", 1);
        i0.ɵɵelementStart(1, "div", 2)(2, "div", 3);
        i0.ɵɵrepeaterCreate(3, YieldCurveComponent_For_4_Template, 5, 6, "div", 4, _forTrack0);
        i0.ɵɵconditionalCreate(5, YieldCurveComponent_Conditional_5_Template, 3, 0, "button", 5);
        i0.ɵɵconditionalCreate(6, YieldCurveComponent_Conditional_6_Template, 3, 0, "button", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(7, YieldCurveComponent_Conditional_7_Template, 1, 0, "ycn-loading-symbol", 6)(8, YieldCurveComponent_Conditional_8_Template, 4, 1, "div", 7)(9, YieldCurveComponent_Conditional_9_Template, 1, 4, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(10, "ycn-feature-needed", null, 0);
    } if (rf & 2) {
        i0.ɵɵconditional(!ctx.isDashboardModule ? 0 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵrepeater(ctx.dateSeries);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.canAddMoreDates && ctx.userCanEdit ? 5 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.activeDatesCount > 1 && ctx.userCanEdit ? 6 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.isLoading ? 7 : ctx.errorMessage ? 8 : 9);
    } }, dependencies: [i5.FeatureNeededComponent, i6.LoadingSymbolComponent, i7.SimpleDropdownComponent, i8.SingleDatePickerComponent], encapsulation: 2 });
